import { useId } from 'react';

/**
 * The waving-person glyph with the design's lime radial gradient + inner shadow
 * baked in (Figma "Individual" icon on the Find players banner). `className`
 * only controls size.
 */
export default function IndividualGradient({ className }: { className?: string }) {
  const uid = useId().replace(/:/g, '');
  const gradientId = `individual-gradient-${uid}`;
  const filterId = `individual-inner-shadow-${uid}`;

  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter={`url(#${filterId})`}>
        <path
          d="M14.9286 34.9997V14.6247C12.623 14.0136 10.7413 12.7914 9.28356 10.958C7.82578 9.12469 6.95745 7.04135 6.67856 4.70802C6.62301 4.31913 6.76189 3.99302 7.09523 3.72969C7.42856 3.46635 7.81745 3.33413 8.26189 3.33302C8.70634 3.33191 9.09523 3.45024 9.42856 3.68802C9.76189 3.9258 9.95634 4.25191 10.0119 4.66635C10.3175 6.66635 11.1786 8.33302 12.5952 9.66635C14.0119 10.9997 15.7619 11.6664 17.8452 11.6664H22.0119C22.8452 11.6664 23.623 11.8191 24.3452 12.1247C25.0674 12.4302 25.7202 12.8747 26.3036 13.458L32.6786 19.833C32.9841 20.1386 33.1369 20.5275 33.1369 20.9997C33.1369 21.4719 32.9841 21.8608 32.6786 22.1664C32.373 22.4719 31.9841 22.6247 31.5119 22.6247C31.0397 22.6247 30.6508 22.4719 30.3452 22.1664L24.9286 16.7497V34.9997C24.9286 35.4719 24.7686 35.868 24.4486 36.188C24.1286 36.508 23.733 36.6675 23.2619 36.6664C22.7908 36.6652 22.3952 36.5052 22.0752 36.1864C21.7552 35.8675 21.5952 35.4719 21.5952 34.9997V26.6664H18.2619V34.9997C18.2619 35.4719 18.1019 35.868 17.7819 36.188C17.4619 36.508 17.0663 36.6675 16.5952 36.6664C16.1241 36.6652 15.7286 36.5052 15.4086 36.1864C15.0886 35.8675 14.9286 35.4719 14.9286 34.9997ZM19.9286 9.99969C19.0119 9.99969 18.2275 9.67357 17.5752 9.02135C16.923 8.36913 16.5963 7.58413 16.5952 6.66635C16.5941 5.74857 16.9208 4.96413 17.5752 4.31302C18.2297 3.66191 19.0141 3.33524 19.9286 3.33302C20.843 3.3308 21.628 3.65746 22.2836 4.31302C22.9391 4.96857 23.2652 5.75302 23.2619 6.66635C23.2586 7.57969 22.9325 8.36469 22.2836 9.02135C21.6347 9.67802 20.8497 10.0041 19.9286 9.99969Z"
          fill={`url(#${gradientId})`}
        />
      </g>
      <defs>
        <filter
          id={filterId}
          x="6.66666"
          y="2.70801"
          width="26.4702"
          height="33.958"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.625" />
          <feGaussianBlur stdDeviation="0.625" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.552621 0 0 0 0 0.831731 0 0 0 0 0.366548 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_37300_113491" />
        </filter>
        <radialGradient
          id={gradientId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.9284 8.33301) rotate(90.0538) scale(28.3334 22.4997)"
        >
          <stop offset="0.0243049" stopColor="#D9FF5D" />
          <stop offset="0.545037" stopColor="#CFFF32" />
          <stop offset="1" stopColor="#8CB600" />
        </radialGradient>
      </defs>
    </svg>
  );
}
